module.exports = __webpack_public_path__ + "static/media/group.93b52ff2.png";